import { css } from 'aphrodite';
import * as React from 'react';
import { IPrizeLog } from '../../../../../extViewmodels';
import { LoadingSpinner } from '../../../../../web/components/LoadingSpinner';
import { styleSheet } from '../styles';
import { ListItem } from './ListItem';

interface IProps {
	isLoading?: boolean;
	items: IPrizeLog[];
	setGameTokenAsPaid?: (gameTokenId: string) => void;
}

export const ListItemsContainer: React.FC<IProps> = ({ isLoading, items, setGameTokenAsPaid }) => {
	if (isLoading) {
		return <LoadingSpinner type='large' className={css(styleSheet.loadingSpinner)} />;
	}
	return (
		<div className={css(styleSheet.list)}>
			{items?.map(item => (
				<ListItem key={item?.gameToken?.id} item={item} setGameTokenAsPaid={setGameTokenAsPaid} />
			))}
		</div>
	);
};
